import React, { useState } from 'react';
import { Form, Input, Collapse, Icon, Row, Col } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './ComponentsStylesheet.css';
import arrayMove from 'array-move';
import Quill from "quill";

const Font = Quill.import('formats/font');
// We do not add Aref Ruqaa since it is the default
Font.whitelist = ['Montserrat', 'Serif', 'Monospace','Sans Serif', 'Anton'];
Quill.register(Font, true);

const { Panel } = Collapse;

const Component = ({ questions }) => {
    const createPanels = questions => {
        return questions.map((entry, index) => {
            return (
                <Panel
                    header={
                        <span className="faq-item-title">
                            <Icon type="menu" className="faq-item-title-icon" />
                            <div className="faq-item-title-text">{entry.question}</div>
                        </span>
                    }
                    key={index}>
                    <div dangerouslySetInnerHTML={{ __html: entry.answer }} className="ant-typography" />
                </Panel>
            );
        });
    };
    return (
        <Collapse expandIconPosition="right" className="faq f-size-1-dot-1-em">
            {createPanels(questions)}
        </Collapse>
    );
};
Component.defaultProps = {
    questions: [
        { question: 'First question', answer: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>' },
        { question: 'Second question', answer: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>' }
    ]
};

const EditForm = props => {
    const { getFieldDecorator, getFieldValue } = props.form;
    const [faq, setFaq] = useState(props.questions);
    const toolbarOptions = [
        [{ font: Font.whitelist }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme

        ['link'],
        ['clean'] // remove formatting button
    ];

    props.form.mapValuesToProps = values => {
        values.questions = values.questions.map((question, i) => ({ question: question, answer: values.answers[i] }));
        delete values.answers;

        return values;
    };

    const validateQuestion = (rule, value, callback) => {
        validateStringMinLength(10, "question's title", value, callback);
    };
    const validateAnswer = (rule, value, callback) => {
        validateStringMinLength(50, 'provided answer', props.form.getFieldInstance(rule.field).editor.getText(), callback);
    };
    const validateStringMinLength = (minLength, fieldName, value, callback) => {
        if (value && value.trim().length >= minLength) {
            callback();
            return;
        } else {
            callback(`The ${fieldName} should be at least ${minLength} characters. (${value ? value.trim().length : 0}/${minLength})`);
        }
    };

    const handleRemoveQuestion = index => {
        let questionFields = getFieldValue('questions');
        let answerFields = getFieldValue('answers');

        let newFaq = questionFields.map((question, i) => ({ question: question, answer: answerFields[i] }));
        newFaq.splice(index, 1);
        props.form.resetFields();

        setFaq(newFaq);
    };
    const handleAddQuestion = e => {
        let newFaq = faq.concat({ question: '', answer: '' });
        setFaq(newFaq);
    };
    const handleMoveQuestionUp = index => {
        if (index > 0) {
            let questionFields = getFieldValue('questions');
            let answerFields = getFieldValue('answers');

            let newFaq = questionFields.map((question, i) => ({ question: question, answer: answerFields[i] }));
            props.form.resetFields();

            setFaq(arrayMove(newFaq, index, --index));
        }
    };
    const handleMoveQuestionDown = index => {
        let questionFields = getFieldValue('questions');
        let answerFields = getFieldValue('answers');

        if (index + 1 < questionFields.length) {
            let newFaq = questionFields.map((question, i) => ({ question: question, answer: answerFields[i] }));
            props.form.resetFields();

            setFaq(arrayMove(newFaq, index, ++index));
        }
    };

    const createFormItems = () => {
        return faq.map((entry, index) => (
            <Row type="flex" justify="space-between" className="faqForm-item" key={index}>
                <Col span={22}>
                    <Form.Item required hasFeedback>
                        {getFieldDecorator(`questions[${index}]`, {
                            rules: [
                                {
                                    validator: validateQuestion
                                }
                            ],
                            initialValue: entry.question
                        })(<Input placeholder="Question" />)}
                    </Form.Item>
                    <Form.Item required hasFeedback>
                        {getFieldDecorator(`answers[${index}]`, {
                            rules: [
                                {
                                    validator: validateAnswer
                                }
                            ],
                            initialValue: entry.answer
                        })(<ReactQuill placeholder="Answer" modules={{ toolbar: toolbarOptions }} theme="snow" />)}
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <div className="faqForm-actions">
                        {faq.length > 1 ? (
                            <React.Fragment>
                                <Icon type="minus-circle-o" className="clickable" title="Remove question" onClick={handleRemoveQuestion.bind(this, index)} />
                                <Icon type="up-circle" className="clickable" title="Move question up" onClick={handleMoveQuestionUp.bind(this, index)} />
                                <Icon type="down-circle" className="clickable" title="Move question down" onClick={handleMoveQuestionDown.bind(this, index)} />
                            </React.Fragment>
                        ) : null}
                        {faq.length === index + 1 ? <Icon type="plus-circle-o" className="clickable" title="Add new question" onClick={handleAddQuestion} /> : null}
                    </div>
                </Col>
            </Row>
        ));
    };

    return (
        <React.Fragment>
            <label className="ant-form-item-required" title="Questions" style={{ marginBottom: '1rem', display: 'block' }}>
                Questions
            </label>
            {createFormItems()}
        </React.Fragment>
    );
};
EditForm.defaultProps = {
    questions: [
        { question: 'First question', answer: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>' },
        { question: 'Second question', answer: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>' }
    ]
};

export { Component, EditForm };
